import { DrupalBaseModel } from './drupal-base.model';
import { LabelValueModel } from './label-value.model';
import { SpecialtyModel } from './specialty.model';
import { NoteModel } from './note.model';

export class ProgramSearchResultModel extends DrupalBaseModel {
  public specialtyName: string;
  public programName: string;
  public programNumber: string;
  public addressLine1: string;
  public addressLine2: string;
  public city: string;
  public state: string;
  public country: string;
  public isExpanded: boolean;
  public programInfo: string[];
  public programInfoMobile: string[];
  public iconState: string;
  public count: number;
  public webSite: string;
  public surveyData: LabelValueModel[];
  public specialty: SpecialtyModel;
  public workingCopyUrl: string;
  public notes: NoteModel;
  public geoLocation: any;
  public aci_score: string;
  public addedToCompare: false;

  constructor(values?: Partial<ProgramSearchResultModel>) {
    super(values);

    Object.assign(this, values);
  }
}
